import { useRef } from 'react';
import { useOutsideClick, useVisible, useColorTheme } from 'src/hooks';
import { ReactTooltip } from 'src/v2/commonComponents/ReactTooltip';
import { NewEditorButton } from './components/NewEditorButton';
import { AddConversationButton } from 'src/v2/components/AddConversationButton';
import { ArtifactType } from 'src/types';
import { Button } from 'src/v2/commonComponents/Button';
import lightIcon from 'src/images/icons/new_chat_icon_light.svg';
import darkIcon from 'src/images/icons/new_chat_icon_dark.svg';
import styles from './NewContentButton.module.scss';

const anchorId = 'new-content-tooltip';

export const NewContentButton = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isVisible, onVisibilityRemove, onVisibilityToggle } = useVisible();
  const { isDarkTheme } = useColorTheme();

  const handleOutsideClick = () => {
    if (isVisible) {
      onVisibilityRemove();
    }
  };

  useOutsideClick(containerRef, handleOutsideClick);

  return (
    <div role="button" tabIndex={0} ref={containerRef}>
      <Button
        data-e2e="new-content-button"
        onClick={onVisibilityToggle}
        className={styles.triggerButton}
        tabIndex={-1}
        id={anchorId}
        shape="round"
        color="transparent"
      >
        <img
          referrerPolicy="no-referrer"
          src={isDarkTheme ? darkIcon : lightIcon}
          alt="Ninjatech AI"
          width={40}
          height={40}
        />
      </Button>

      <ReactTooltip
        className={styles.tooltip}
        place="left-start"
        isOpen={isVisible}
        id={anchorId}
      >
        <div className={styles.tooltipContainer} onClick={onVisibilityRemove}>
          <AddConversationButton appearance="transparent-button" />

          <hr className="divider" />

          <NewEditorButton withTitle buttonType={ArtifactType.TEXT} />
          <NewEditorButton withTitle buttonType={ArtifactType.CODE} />
        </div>
      </ReactTooltip>
    </div>
  );
};
